import { esc } from '../components/shared.js'
import { GRIZZLY_BEAR_MARK, SILVERBACK_WORDMARK } from './brand.js'

/**
 * Google is the only identity provider, so this view no longer branches on
 * AUTH_PROVIDER — it has one thing to render.
 *
 * The branch is gone, not commented out. Keeping a dead read "just in case"
 * is what produced the bug this file used to carry: a hardcoded copy string
 * said "Sign in with GitHub" while every other layer had moved to Google.
 * esbuild's PROVIDER_REQUIRED_KEYS still refuses to build without the Google
 * configuration, so a misconfigured bundle fails at build time rather than
 * rendering the wrong button.
 */
const WORKSPACE_DOMAIN = process.env.GOOGLE_WORKSPACE_DOMAIN ?? ''

/** Google 'G', in its mandated four brand colours. */
const GOOGLE_ICON = `<svg class="login-gh-icon" viewBox="0 0 18 18" aria-hidden="true">
        <path fill="#4285F4" d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 01-1.8 2.72v2.26h2.92c1.7-1.57 2.68-3.88 2.68-6.62z"/>
        <path fill="#34A853" d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.81.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.03-3.7H.96v2.33A9 9 0 009 18z"/>
        <path fill="#FBBC05" d="M3.97 10.72a5.4 5.4 0 010-3.44V4.95H.96a9 9 0 000 8.1l3.01-2.33z"/>
        <path fill="#EA4335" d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58C13.46.89 11.43 0 9 0A9 9 0 00.96 4.95l3.01 2.33C4.68 5.16 6.66 3.58 9 3.58z"/>
      </svg>`

/**
 * Renders the full-page login view.
 * @param errorMsg Optional raw (unescaped) error message to display. Pass plain
 *   strings; escaping is applied here at the renderer boundary.
 */
export function renderLoginPage(errorMsg?: string): string {
  const errorHtml = errorMsg ? `<p class="login-error">${esc(errorMsg)}</p>` : ''
  const icon = GOOGLE_ICON
  const label = 'Sign in with Google'
  // Naming the domain tells someone with two Google accounts which one to pick,
  // before Google rejects the wrong one with a message they cannot act on.
  const hint = WORKSPACE_DOMAIN
    ? `Use your ${esc(WORKSPACE_DOMAIN)} account.`
    : 'Use your work Google account.'

  return `<div class="login-page">
  <div class="login-card">
    <div class="login-brand">${SILVERBACK_WORDMARK}</div>
    <div class="login-logo">
      ${GRIZZLY_BEAR_MARK}
      <span class="login-logo-name">grizzly</span>
    </div>
    <p class="login-desc">Autonomous coding agent dashboard</p>
    ${errorHtml}
    <button class="login-btn" id="login-btn" type="button">
      ${icon}
      ${esc(label)}
    </button>
    ${
      errorMsg
        ? `
    <button class="login-retry-btn" id="login-retry-btn" type="button" onclick="window.clearAuthAndRetry()">
      Clear storage &amp; Retry
    </button>`
        : ''
    }
    <p class="login-hint">${hint}</p>
  </div>
</div>`
}
